/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { closeCircle } from "../assets/close-circle";
import { Icon, type IconBaseProps } from "../icon";

export const IconCloseCircle = (props: IconBaseProps) => <Icon {...props} svg={closeCircle} />;

IconCloseCircle.displayName = "IconCloseCircle";
